import { render, staticRenderFns } from "./simulate-new-node.vue?vue&type=template&id=07b4060a&scoped=true&"
import script from "./simulate-new-node.vue?vue&type=script&lang=ts&"
export * from "./simulate-new-node.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b4060a",
  null
  
)

export default component.exports